import { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import store from "../../../../../store";
import {
  setSelectedEntityType,
  setTerritoryLanguageFilter,
} from "../../../../../features/metaEntitiesSlice";

const TerritoryFilter = () => {
  const [searchLanguage, setSearchLanguage] = useState("");
  const { metaEntityList, territoryLanguageFilter } = useSelector(
    (state: any) => state?.metaEntity
  );

  const filterConfig = [
    {
      key: "Language",
      label: "Select Language",
      searchTerm: searchLanguage,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchLanguage(e.target.value),
      selectedOption: territoryLanguageFilter,
      filterName: "language",
      data: metaEntityList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setTerritoryLanguageFilter(updatedSelection)),
      count: territoryLanguageFilter && territoryLanguageFilter.length,
      colorSelected:
        territoryLanguageFilter !== null && territoryLanguageFilter?.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    store.dispatch(setSelectedEntityType(""));
    store.dispatch(setTerritoryLanguageFilter(null));
    setSearchLanguage("");
  };

  return (
    <Box data-tracker="233">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default TerritoryFilter;
